/**
 * 主题（浅色 / 深色）工具
 *
 * 实现方式：由 <html> 上的 `dark` 类控制。
 *   - Element Plus 的暗色变量（element-plus/theme-chalk/dark/css-vars.css）就挂在 html.dark 上
 *   - 项目自身的界面适配写在 App.vue 的 `html.dark ...` 样式里
 *
 * main.js 在挂载前调用 applyTheme(getSavedTheme()) 提前应用，避免刷新时闪一下浅色。
 */
export const THEME_KEY = 'ops_theme'
export const DARK_CLASS = 'dark'

/** 读取用户上次选择的主题，默认浅色 */
export function getSavedTheme() {
  try {
    return localStorage.getItem(THEME_KEY) === 'dark' ? 'dark' : 'light'
  } catch (e) {
    // 隐私模式下 localStorage 不可用，降级为浅色
    return 'light'
  }
}

/** 把主题应用到 <html>，并记住选择；返回是否深色 */
export function applyTheme(theme) {
  const dark = theme === 'dark'
  document.documentElement.classList.toggle(DARK_CLASS, dark)
  try {
    localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light')
  } catch (e) {
    // 存不了不影响本次会话使用
  }
  return dark
}

/** 当前是否深色（以 <html> 上的类为准，避免和 main.js 的状态不一致） */
export function isDarkTheme() {
  return document.documentElement.classList.contains(DARK_CLASS)
}
